(function()
{
	//Import classes
	var BitmapText = include("PIXI.extras.BitmapText");
	var Button = include("springroll.pixi.Button");
	var ButtonSounds = include("springroll.ButtonSounds");
	var Container = include("PIXI.Container");
	var Sprite = include('PIXI.Sprite');
	var Texture = include('PIXI.Texture');
	var Application = include('springroll.Application');

	/**
	 * Contains the current score the the pause button
	 * @class HUD
	 * @extends PIXI.Container
	 */
	var HUD = function(config)
	{
		Container.call(this);

		/**
		 * Reference to the application
		 * @property {springroll.Application} app
		 */
		this.app = Application.instance;

		/**
		 * HUD configuration
		 * @property {Object} config
		 */
		this.config = config;

		/**
		 * The background display
		 * @property {PIXI.Sprite} background
		 */
		this.background = new Sprite(
			Texture.fromImage(config.background.art)
		);
		setPosition(this.background, config.background);

		/**
		 * The text input
		 * @property {PIXI.extras.BitmapText} distanceText
		 */
		this.distanceText = new BitmapText(
			config.distanceText.text,
			config.distanceText.style
		);
		this.distanceText.setPivotToAlign = true;
		setPosition(this.distanceText, config.distanceText);

		/**
		 * The text input
		 * @property {PIXI.extras.BitmapText} distanceLabel
		 */
		this.distanceLabel = new BitmapText(
			config.distanceLabel.text,
			config.distanceLabel.style
		);
		this.distanceText.setPivotToAlign = true;
		setPosition(this.distanceLabel, config.distanceLabel);

		/**
		 * The pause button
		 * @property {springroll.pixi.Button} pauseButton
		 */
		this.pauseButton = new Button(config.pauseButton.art);
		this.pauseButton.scale.x = this.pauseButton.scale.y = 1.2;
		//get the hit area of the pause button on the button only, not the hanging rope portion of the sprite
		this.pauseButton.hitArea = new PIXI.Rectangle(10, 8, 48, 45);

		//no 'click' sound for the pause button because it fires AFTER the game the is resumed, resulting in a random-seeming click sound happening  
		this.buttonSounds = new ButtonSounds(null, "ButtonRollover", this.pauseButton);

		this.addChild(this.background);
		this.addChild(this.distanceText);
		this.addChild(this.pauseButton);
		this.addChild(this.distanceLabel);

		this.app.scaling.addItems(this, config.scaling);

		this.show(false);
	};

	// Extends container
	var s = Container.prototype;
	var p = extend(HUD, Container);

	// Set the position of a display object from data
	var setPosition = function(obj, data)
	{
		obj.x = data.x || 0;
		obj.y = data.y || 0;
	};

	/**
	 * Show the display
	 * @method show
	 * @param {boolean} show
	 */
	p.show = function(show)
	{
		if (show === undefined)
		{
			show = true;
		}
		this.visible = show;
		if (show)
		{
			this.distance = "";
		}
	};

	/**
	 * Set the instance
	 * @property {String} distance
	 */
	Object.defineProperty(p, 'distance',
	{
		set: function(str)
		{
			this.distanceText.text = str;
		}
	});

	/**
	 * destroy and don't use after this
	 * @method destroy
	 */
	p.destroy = function()
	{
		//Remove from scaling
		var scaling = this.app.scaling;
		scaling.removeItems(this, this.config.scaling);

		s.destroy.call(this, true);

		this.distanceLabel = null;
		this.background = null;
		this.distanceText = null;
		this.pauseButton = null;
		this.config = null;

		this.buttonSounds.destroy();
	};


	//Assign to namespace
	namespace('nature').HUD = HUD;

}());
